export const hasUppercaseError = { hasUppercase: true };

export function hasUppercaseLetter(string: string) {
  return /[A-Z]/.test(string);
}
